module.exports = __webpack_public_path__ + "static/media/FIDELITY.3af0ea40.jpg";